var _rect, _circle, _line, _line2, _line3, _line4, _line5, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutonomia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 167,
    height: 167,
    rx: 25,
    fill: "#D4A266"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 60,
    r: 12,
    stroke: "white",
    strokeWidth: 4,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 93.5,
    y1: 72,
    x2: 93.5,
    y2: 110,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 93.5,
    y1: 82,
    x2: 65,
    y2: 95,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 93.5,
    y1: 82,
    x2: 122,
    y2: 95,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 93.5,
    y1: 110,
    x2: 72,
    y2: 135,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 93.5,
    y1: 110,
    x2: 115,
    y2: 135,
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 93.5,
    y: 155,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fill: "white"
  }, "\n    Autonom\xEDa\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutonomia);
export default __webpack_public_path__ + "static/media/Autonomia.bce200e8c34804ccdb1e857d3637a63f.svg";
export { ForwardRef as ReactComponent };